import { render, staticRenderFns } from "./documentInfoView.vue?vue&type=template&id=f490e3e6&"
import script from "./documentInfoView.vue?vue&type=script&lang=js&"
export * from "./documentInfoView.vue?vue&type=script&lang=js&"
import style0 from "./documentInfoView.vue?vue&type=style&index=0&id=f490e3e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports